import styled from 'styled-components';

export default styled.div`
	display: flex;
	padding-top: 1rem;
	.custom-tab-menu {
		margin-left: auto;
		margin-bottom: 3rem;

		.motif-tab-button{
			max-width: 15rem;
			color: ${(props) => props.theme.color[`grey400`]} !important;
			font-weight: 300;
			font-size: 1.4rem;
			border: solid 0.1rem ${(props) => props.theme.color[`grey300`]};
			border-radius: 0.4rem;
			padding: 1rem 2rem !important;
    		margin-left: 1rem;
			box-shadow: 0.1rem 0.1rem 0.8rem ${(props) => props.theme.color[`grey200`]};
			.motif-icon{
				display: flex;
				align-items: center;
				svg{
					path{
						fill: ${(props) => props.theme.color[`grey400`]};
					}
					
				}
			}
			&.motif-active{
				color: ${(props) => props.theme.color[`grey500`]} !important;
				box-shadow: none !important;
				border: solid 0.1rem ${(props) => props.theme.color[`grey500`]};
				.motif-icon{
					svg{
						path{
							fill: ${(props) => props.theme.color[`grey500`]};
						}
						
					}
				}
			}
			&:hover:not(.motif-active){
				box-shadow: 0.1rem 0.1rem 0.8rem ${(props) => props.theme.color[`grey250`]} !important;
			}
			&:hover{
				text-shadow: none !important;
			}
		}

		.motif-tab-navigation{
			padding: 0;
			margin-bottom: 0;
		}
	}
	.motif-search {
		width: 35rem;
		.motif-form-field {
			height: 100%;
			.motif-search-input-wrapper {
				height: 100%;
				.motif-input,
				.motif-input::placeholder {
					font-weight: 300;
				}
			}
		}
	}
`;
